module.exports = __webpack_public_path__ + "img/img65.b352d1f0.png";